import { createContext } from 'react';

import type { NotificationItem } from '@surface/notifications';

import type { NotificationFilter } from '../hooks/types';
import type { UseKnockNotificationsReturn } from '../hooks/use-knock-notifications';

export type NotificationsFeedContextValue = {
  isAvailable: boolean;
  items: NotificationItem[];
  unreadCount: number;
  isLoading: boolean;
  filter: NotificationFilter;
  setFilter: (filter: NotificationFilter) => void;
  reset: UseKnockNotificationsReturn['reset'];
  markAsRead: UseKnockNotificationsReturn['markAsRead'];
  markAllAsRead: UseKnockNotificationsReturn['markAllAsRead'];
  markAsUnread: UseKnockNotificationsReturn['markAsUnread'];
  markAsSeen: UseKnockNotificationsReturn['markAsSeen'];
  archive: UseKnockNotificationsReturn['archive'];
  hasNextPage: boolean;
  loadMore: UseKnockNotificationsReturn['loadMore'];
  isLoadingMore: boolean;
  prefetchAll: UseKnockNotificationsReturn['prefetchAll'];
};

export const NotificationsFeedContext =
  createContext<NotificationsFeedContextValue | null>(null);
